import { Button, InputAdornment, Link, useMediaQuery } from '@material-ui/core'
import React, { useState, useContext, useEffect } from 'react'
import PrimaryButton from '../../../../Product/components/atoms/PrimaryButton'
import '../../molecules/ProductCard/ProductCard.css'
import SecondaryButton from '../../../../Product/components/atoms/SecondaryButton'
import { useHistory } from 'react-router-dom'
// import Popup from '../../../../product/components/organisms/Popup'
// import Timer from '../../../common/timer'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import BuyerContext from '../../../../Product/context/buyer/buyerContext'
import AuthContext from '../../../../Product/context/auth/authContext'
import StripeCardContext from '../../../../Product/context/stripe/card/cardContext'
import DirectStripeContext from '../../../../Product/context/directStripe/directStripeContext'
import AlertContext from '../../../../Product/context/alert/alertContext'
import { useTranslation } from 'react-i18next'
import CustomDialog from '../../organisms/Dialog'
import { handleRedirectInternal } from '../../../common/components'
import { currencyFormat } from '../../../common/components'
import { mapData } from '../../../../Product/common/components'
import CurrencyConverterFormat from '../../../../utils/CommonFunctionality/CurrencyConverter/CurrencyConverterFormat'
import { getBiddingHistory } from '../../../../Services/Bidding.service'
import axios from 'axios'
import WizardTermsPopup from '../../../../Themes/Liquidation_two/AuctionTerms/wizardTermsPopup'
import { useAuctionTerms } from '../../../../Themes/Liquidation_two/AuctionTerms/useAuctionTerms'
import ReactImageGallery from 'react-image-gallery'
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min'
// import { isMobile } from 'react-device-detect'

const Bidding = (props) => {
    const buyerContext = useContext(BuyerContext)
    const authContext = useContext(AuthContext)
    const alertContext = useContext(AlertContext)
    const { t } = useTranslation()
    const { setAlert } = alertContext
    const { get_all_card_details, get_skyflow_cards } = useContext(StripeCardContext)
    const { usercards } = useContext(DirectStripeContext)
    const isBuyBestProject = global.storeConfigration?.bodyClass2?.value === 'buyBestProject'
    const [bidpopuptext, setBidpopuptext] = useState('')
    let {
        bidConfirm,
        bidConfirmRetailRush,
        markasassurance,
        responseStatus: buyerresponse,
    } = buyerContext
    const { user, isAuthenticated, userCount, updateReferral } = authContext
    const cbidnot = localStorage.setItem('cbidnot', props.data.cbidnot)
    const [cards, setCards] = useState([])
    const [product, setProduct] = useState()
    const [biddingAmount, setBiddingAmount] = useState()
    const [biderrpopup, setBiderrpopup] = useState(false)
    const history = useHistory()
    const [bidding_disable, setBiddingdisable] = useState(false)
    const [return_popup, setReturnPopup] = useState(false)
    const [assurancedis, setBuyerass] = useState(0)
    const [asspopup, setAssPopup] = useState(false)
    const [warrantypopup, setWarrantyPopup] = useState(false)
    const [toggleDialog, setToggleDialog] = useState(false)
    const [bidHistory, setBidHistory] = useState([])
    const [oldBuyerInsurance, setOldBuyerInsurance] = useState(product?.buyerassamount)
    const [buyerInsurance, setBuyerInsurance] = useState(null)
    const [warrantyReturn, setWarrantyReturn] = useState(null)
    const [quickPopup, setQuickPopup] = useState(false)
    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'
    const isBargainTheme = document.body.classList[1] == 'bargains'
    const bidnaaTheme = document.body.className == 'MultiSeller_two bidNaa'
    const isBargainsProject = global.storeConfigration?.bodyClass2?.value === 'bargainsClass'
    const isMobile = useMediaQuery('(max-width:600px)')
    var min_amount = 0,
        max_amount = 0,
        intermediate_value = 0
    const changeDialogStatus = () => {
        setToggleDialog(!toggleDialog)
    }

    useEffect(() => {
        // console.log(props.data, 'this is props data')
        setProduct(props.data)
    }, [props.data])
    const isWizardTheme = document.body.className == 'liquidationTwo wizardTheme'
    const validationArray = Yup.object({
        wsprice: Yup.number()
            .positive('Please enter only numbers for your bid')
            .integer('Amount Should be an integer')
            .typeError('Please enter only numbers for your bid')
            .min(
                product ? parseInt(product.next_bid) : 0,
                `${'Min bid'} ${product ? currencyFormat(product.next_bid) : currencyFormat(0)}`,
            )
            .test('is-decimal', 'Cannot be a decimal', (value) =>
                value ? typeof value === 'number' && value % 1 === 0 : true,
            )
            .required('Enter bid amount'),
    })

    const validationArrayDecimal = Yup.object({
        wsprice: Yup.number()
            .positive('Please enter only numbers for your bid')
            .typeError('Please enter only numbers for your bid')
            .min(
                product ? parseInt(product.next_bid) : 0,
                `${'Min bid'} ${product ? currencyFormat(product.next_bid) : currencyFormat(0)}`,
            )
            .required('Enter bid amount'),
    })

    const { showPopup, setShowPopup, checkTermsAndProceed, acceptTerms } = useAuctionTerms({
        onAccepted: (auctionId) => {},
    })

    const formik = useFormik({
        initialValues: {
            wsprice: '',
            id: 0,
            hard_bid: '',
            bid_increment: 0,
            email: '',
            first_name: '',
            last_name: '',
            producturl: '',
            assurance_check: false,
            warranty_check: false,
        },
        validationSchema:
            global.storeDetails.site_id == 'AS0282' ||
            (global.storeConfigration?.allow_decimal_bidding?.value == 1 && product?.is_decimal_bid)
                ? validationArrayDecimal
                : validationArray,
        onSubmit: async (values) => {
            if (isWizardTheme) {
                const response = await axios.get(
                    `${process.env.REACT_APP_BASE_URL}api/getUserTermsForAuction?site_id=${global.storeDetails.site_id}&user_id=${user?.id}&auction_id=${product?.lotof}`,
                )
                const needsToAcceptTerms = response.data.status === 0
                if (isWizardTheme && needsToAcceptTerms) {
                    props.setAuctionIdRedirect(props?.data?.id)
                    props.setModalOpen(true)
                    return
                }
            }
            if (
                cards.length ||
                global.storeDetails?.theme == 4 ||
                global.storeConfigration?.credit_card_no_need?.value == 1 ||
                user?.check_card == 1
            ) {
                //if (cards[0]?.customer == user?.card_paymentid) {
                if (new Date(props.data.date_added) > new Date()) {
                    return setAlert('Wait until auction starts!', 'warning')
                }
                if (
                    global.storeDetails?.theme == 19 &&
                    values.hard_bid != 0 &&
                    bidHistory.length > 0 &&
                    bidHistory[0]?.user_id == user.id &&
                    bidHistory[1]?.user_id == user.id &&
                    bidHistory[0]?.bidtext === 'HARD BID' &&
                    bidHistory[1]?.bidtext === 'HARD BID'
                ) {
                    setToggleDialog(false)
                    setQuickPopup(false)
                    formik.setSubmitting(false)
                    setBidHistory([])
                    return setAlert(
                        `You have placed quick bids twice. To proceed, please enter your desired amount and submit your maximum bid`,
                        'error',
                    )
                }
                if (props.removePopup) {
                    if (isVarifiedGfTheme) {
                        values.retailRush = 1
                        values.phone = user?.phone || ''
                    }
                    if (
                        isVarifiedGfTheme &&
                        parseInt(global.storeConfigration?.enable_new_bid_api?.value)
                    ) {
                        bidConfirmRetailRush(values)
                        props?.setBidLoading(true)
                    } else {
                        bidConfirm(values)
                    }
                    formik.setTouched({})
                    formik.setFieldValue('wsprice', '')
                } else if (isVarifiedGfTheme || toggleDialog || quickPopup) {
                    if (global?.pluginConfiguration?.return_assurance?.enable == 1) {
                        console.log(
                            oldBuyerInsurance,
                            buyerInsurance,
                            'oldBuyerInsurance != buyerInsurance',
                            product?.buyerassamount,
                        )
                        if (oldBuyerInsurance && oldBuyerInsurance != buyerInsurance) {
                            insert_assurance(1)
                        }
                    }
                    values.producturl = `${window.origin}/${global.storeDetails.id}/productView/${values.id}`
                    if (global.storeConfigration?.bidding_sound?.value == 1) {
                        if (props.audio != '' && props.audio != undefined) {
                            props.audio.play()
                        }
                    }
                    if (isVarifiedGfTheme) {
                        values.retailRush = 1
                        values.phone = user?.phone || ''
                    }
                    if (
                        isVarifiedGfTheme &&
                        parseInt(global.storeConfigration?.enable_new_bid_api?.value)
                    ) {
                        bidConfirmRetailRush(values)
                    } else {
                        bidConfirm(values)
                    }
                    formik.setTouched({})
                    setToggleDialog(false)
                    setQuickPopup(false)

                    formik.setFieldValue('wsprice', '')
                    if (
                        global?.pluginConfiguration?.referral?.enable == 1 &&
                        userCount?.total_bids == 0 &&
                        global?.storeConfigration?.bid_referral_update?.value == 1
                    ) {
                        updateReferral()
                    }
                } else {
                    formik.setSubmitting(false)
                    global.storeDetails?.theme == 19 && !isVarifiedGfTheme
                        ? await getHistory()
                        : null
                    if (
                        global.storeDetails?.theme == 19 &&
                        !isVarifiedGfTheme &&
                        values.hard_bid != 0
                    ) {
                        setQuickPopup(true)
                        formik.handleSubmit()
                    } else {
                        setToggleDialog(true)
                    }
                }
                //}
            } else {
                setAlert('Add a card to bid!', 'error')
                handleRedirectInternal(history, 'dashboard/cards', '', {
                    product_id: props.data.id,
                })
            }
        },
    })

    const getHistory = async () => {
        let response = await getBiddingHistory(props.data.id)
        try {
            if (
                response.data &&
                response.data.success === 'yes' &&
                Array.isArray(response.data.results)
            ) {
                setBidHistory(response.data.results)
            }
        } catch (err) {
            // console.log(err)
        } finally {
            // setLoading(false)
        }
    }

    useEffect(() => {
        formik.values.hard_bid = props.hard
    }, [props.hard])

    useEffect(() => {
        if (global.storeConfigration?.skyflow_integration?.value == 1) {
            if (get_skyflow_cards) {
                setCards(get_skyflow_cards)
            }
        } else {
            if (get_all_card_details) {
                setCards(get_all_card_details.records)
            }
        }
    }, [get_all_card_details, get_skyflow_cards])

    useEffect(() => {
        if (usercards?.length) {
            setCards(usercards)
        }
    }, [usercards])

    useEffect(() => {
        if (product && Number(product.next_bid) >= Number(formik.values.wsprice)) {
            formik.setFieldValue('wsprice', '')
            if (toggleDialog) {
                setAlert('Current Bid Changed Now!', 'warning')
                setToggleDialog(false)
            }
        } else {
            setToggleDialog(false)
        }
    }, [product])
    useEffect(() => {
        if (product) {
            formik.setFieldValue('id', product.id)
            formik.setFieldValue('bid_increment', product.incrementamt)
            if (!product.socket_change) {
                if (parseInt(product.buyerass) > 0) {
                    formik.setFieldValue('assurance_check', true)
                } else {
                    formik.setFieldValue('assurance_check', false)
                }
                if (global?.pluginConfiguration?.warranty_return_sku?.enable == 1) {
                    if (parseInt(product.buyerass) > 0) {
                        formik.setFieldValue('warranty_check', true)
                    } else {
                        formik.setFieldValue('warranty_check', false)
                    }
                }
            }
        }
    }, [product])

    useEffect(() => {
        setOldBuyerInsurance(product?.buyerassamount)
    }, [product?.buyerassamount])
    useEffect(() => {
        if (isAuthenticated) {
            if (user) {
                formik.setFieldValue('email', user.email)
                formik.setFieldValue('first_name', user.first_name)
                formik.setFieldValue('last_name', user.last_name)
                if (
                    global.storeConfigration?.suspended_user_access?.value == 1 &&
                    user?.status == 'suspended'
                ) {
                    setBiddingdisable(false)
                }
            }
        }
    }, [isAuthenticated, user])

    const checkbiddingamount = (e) => {
        if (
            localStorage.getItem('Browsertype') == 'Safari' ||
            localStorage.getItem('Browsertype') == 'Mobile Safari'
        ) {
            if (parseInt(formik.values.wsprice) > parseInt(product.next_bid)) {
                intermediate_value =
                    parseInt(product.incrementamt ? product.incrementamt : 1) *
                    Math.round(
                        parseInt(parseInt(formik.values.wsprice) - parseInt(product.wprice)) /
                            parseInt(product.incrementamt),
                    )
                intermediate_value = parseInt(intermediate_value) + parseInt(product.wprice)
                if (parseInt(formik.values.wsprice) == intermediate_value) {
                    return false
                } else if (parseInt(formik.values.wsprice) < parseInt(intermediate_value)) {
                    max_amount = intermediate_value
                    min_amount = intermediate_value - parseInt(product.incrementamt)
                    setAlert(
                        `Please enter a valid value.The two nearest valid values are ${min_amount} and ${max_amount}`,
                        'error',
                    )
                } else if (parseInt(formik.values.wsprice) > parseInt(intermediate_value)) {
                    min_amount = intermediate_value
                    max_amount = intermediate_value + parseInt(product.incrementamt)
                    setAlert(
                        `Please enter a valid value.The two nearest valid values are ${min_amount} and ${max_amount}`,
                        'error',
                    )
                }
            } else {
                return false
            }
        } else {
            return false
        }
    }

    const buyerass = [
        {
            label: `Add Buyer's Assurance protection for ${currencyFormat(buyerInsurance)} ${
                props?.buyerAssuranceNew
                    ? `\n Get a ${
                          global.storeConfigration?.return_value_days?.value
                              ? global.storeConfigration.return_value_days.value
                              : 4
                      } business-day return guarantee.`
                    : ''
            }`,
            name: 'assurance_check',
            type: 'checkbox_bid',
            class: 'col-12',
            formik: formik,
            disabled:
                parseInt(product?.buyerass ? product.buyerass : 0) > 0 &&
                product?.market_status != 'open'
                    ? true
                    : false,
            onChange: (e) => {
                if (e.target.checked) {
                    formik.setFieldValue('assurance_check', true)
                    insert_assurance(1, 'assurance')
                } else {
                    setAssPopup(true)
                }
            },
        },
    ]
    const warrantyass = [
        {
            label: `Add Warranty Return Protection For ${currencyFormat(warrantyReturn)} ${
                props?.buyerAssuranceNew
                    ? `\n Get a ${
                          global.storeConfigration?.return_value_days?.value
                              ? global.storeConfigration.return_value_days.value
                              : 4
                      } business-day return guarantee.`
                    : ''
            }`,
            name: 'warranty_check',
            type: 'checkbox_bid',
            class: 'col-12',
            formik: formik,
            disabled:
                parseInt(product?.buyerass ? product.buyerass : 0) > 0 &&
                product?.market_status != 'open'
                    ? true
                    : false,
            onChange: (e) => {
                if (e.target.checked) {
                    formik.setFieldValue('warranty_check', true)
                    insert_assurance(1, 'warranty')
                } else {
                    setWarrantyPopup(true)
                }
            },
        },
    ]

    const maxBidAmount = [
        {
            label: global.storeDetails?.theme == 20 ? 'Enter Max Bid' : '',
            name: 'wsprice',
            type: global?.storeConfigration?.bid_box_type?.value
                ? global?.storeConfigration?.bid_box_type?.value
                : 'number',
            helperText: isBargainTheme
                ? ''
                : product?.maxbidamt && props.isBidAuctionBtn
                ? 'My Max Bid: ' + currencyFormat(product?.maxbidamt)
                : null,
            placeholder:
                product && product.next_bid
                    ? `${currencyFormat(
                          product.next_bid,
                          '',
                          '',
                          (global.storeConfigration?.allow_decimal_bidding?.value &&
                              product?.is_decimal_bid) == 1
                              ? 2
                              : 0,
                      )}`.replace('$ ', '')
                    : '',
            class: '',
            size: props.inputSize ? props.inputSize : 'small',
            autoFocus: false,
            pattern:
                global.storeDetails.site_id == 'AS0282' ||
                (global.storeConfigration?.allow_decimal_bidding?.value &&
                    product?.is_decimal_bid) == 1
                    ? '[0-9]*[.][0-9]*'
                    : '[0-9]*',
            formik: formik,
            onChange: (e) => {
                const { value } = e.target
                value.replace(/[^0-9]+/g, '')
                formik.setFieldValue('wsprice', value)
            },
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
            step:
                global.storeDetails.site_id == 'AS0282' ||
                (global.storeConfigration?.allow_decimal_bidding?.value == 1 &&
                    product?.is_decimal_bid)
                    ? 0.01
                    : global.storeDetails.theme == 4
                    ? 0
                    : product?.incrementamt,
            min: global.storeDetails.theme == 4 ? 0 : product?.next_bid,
            onKeyup: (e) => {
                checkbiddingamount(e)
            },
            onBlur: () => {
                if (global?.pluginConfiguration?.return_assurance?.enable == 1) {
                    getBuyerAssuranceValue()
                }
                if (global?.pluginConfiguration?.warranty_return_sku?.enable == 1) {
                    getWarrantyReturnValue()
                }
            },
        },
    ]

    const bidAmount = [
        {
            label: !bidnaaTheme
                ? t('$ Enter Bid')
                : `${global.storeConfigration?.currency_format?.value} Enter Bid`,
            name: 'wsprice',
            type: global?.storeConfigration?.bid_box_type?.value
                ? global?.storeConfigration?.bid_box_type?.value
                : 'number',
            placeholder:
                product && product.next_bid
                    ? `${currencyFormat(
                          product.next_bid,
                          '',
                          '',
                          global.storeConfigration?.allow_decimal_bidding?.value == 1 &&
                              product?.is_decimal_bid
                              ? 2
                              : 0,
                      )}`
                    : '',
            class: '',
            size: props.inputSize ? props.inputSize : 'small',
            autoFocus: false,
            pattern:
                global.storeDetails.site_id == 'AS0282' ||
                (global.storeConfigration?.allow_decimal_bidding?.value == 1 &&
                    product?.is_decimal_bid)
                    ? '[0-9]*[.][0-9]*'
                    : '[0-9]*',
            formik: formik,
            onChange: (e) => {
                const { value } = e.target
                // const regex = /^(0*[1-9][0-9]*(\.[0-9]*)?|0*\.[0-9]*[1-9][0-9]*)$/
                // if (!value || regex.test(value.toString())) {
                //     formik.setFieldValue('wsprice', value)
                // }
                value.replace(/[^0-9]+/g, '')
                formik.setFieldValue('wsprice', value)
            },
            step:
                global.storeDetails.site_id == 'AS0282' ||
                (global.storeConfigration?.allow_decimal_bidding?.value == 1 &&
                    product?.is_decimal_bid)
                    ? 0.01
                    : global.storeDetails.theme == 4
                    ? 0
                    : product?.incrementamt,
            min: global.storeDetails.theme == 4 ? 0 : product?.next_bid,
            onKeyup: (e) => {
                checkbiddingamount(e)
            },
            onBlur: () => {
                if (global?.pluginConfiguration?.return_assurance?.enable == 1) {
                    getBuyerAssuranceValue()
                }
                if (global?.pluginConfiguration?.warranty_return_sku?.enable == 1) {
                    getWarrantyReturnValue()
                }
            },
        },
    ]

    useEffect(() => {
        setBidpopuptext(
            global.storeConfigration?.bid_confirmation_text?.value
                ? global.storeConfigration.bid_confirmation_text.value
                : '',
        )
    }, [])
    const getBuyerAssuranceValue = () => {
        const assurance = global?.pluginConfiguration?.return_assurance?.access_key
        const bidPrice = parseFloat(props?.data?.currentUserBidAmount)

        const amount = assurance.range.find(
            (val) => bidPrice >= parseFloat(val.from) && bidPrice <= parseFloat(val.to),
        )

        if (amount) {
            setBuyerInsurance(amount.amount)
        } else {
            setBuyerInsurance(assurance.default)
        }
    }

    const getWarrantyReturnValue = () => {
        const assurance = global?.pluginConfiguration?.warranty_return_sku?.access_key
        const bidPrice = parseFloat(formik.values.wsprice)
        const amount = assurance.default
        if (amount) {
            setWarrantyReturn(amount)
        } else {
            setWarrantyReturn(0)
        }
    }
    useEffect(() => {
        if (bidpopuptext != '') {
            var bid_text = global.storeConfigration?.bid_confirmation_text?.value.replace(
                /{{amount}}/g,
                currencyFormat(formik.values.wsprice),
            )

            setBidpopuptext(bid_text)
        }
        setBiddingAmount(formik.values.wsprice)

        if (global?.pluginConfiguration?.return_assurance?.enable == 1) {
            getBuyerAssuranceValue()
        }
        if (global?.pluginConfiguration?.warranty_return_sku?.enable == 1) {
            getWarrantyReturnValue()
        }
    }, [formik.values.wsprice])
    const checkbiderrorpopup = async (event) => {
        event.preventDefault()

        if (isWizardTheme) {
            const allowed = await checkTermsAndProceed({
                auctionId: product?.lotof,
            })
            if (!allowed) {
                return
            }
        }
        if (
            parseInt(product.next_bid) > parseInt(formik.values.wsprice) &&
            global.storeDetails.theme == 4
        ) {
            setBiderrpopup(true)
            formik.handleSubmit()
        } else {
            formik.handleSubmit()
        }
    }

    const handleBidButton = (bidValue) => {
        formik.values.wsprice = bidValue
        if (formik.values.wsprice != '') {
            formik.handleSubmit()
        }
    }

    useEffect(() => {
        if (global.storeConfigration?.prepopulate_bid?.value == '1') {
            formik.setFieldValue('wsprice', parseInt(product?.next_bid))
        }
    }, [product, product?.next_bid])

    useEffect(() => {
        const userBid = bidHistory.some((item) => item.user_id == user.id)
        if (global.storeDetails?.theme == 19 && userBid && !isVarifiedGfTheme) {
            getHistory()
        }
    }, [props.data.bids])

    // useEffect(() => {
    //     if (formik.values.check_off) {
    //         if (formik.values.assurance_check) {
    //             insert_assurance(1)
    //         } else {
    //             setAssPopup(true)
    //         }
    //     } else {
    //         formik.setFieldValue('check_off', true)
    //     }
    // }, [formik.values.assurance_check])

    const insert_assurance = (insert_or_del, type) => {
        markasassurance(
            {
                site_id: global.storeDetails?.site_id ? global.storeDetails.site_id : '',
                user_id: user?.id,
                project_id: product.id,
                amount: type == 'assurance' ? buyerInsurance : warrantyReturn,
                insert_or_del: insert_or_del,
                sku_id: global?.pluginConfiguration?.warranty_return_sku?.access_key?.sku_id,
            },
            type,
        )
        setBuyerass(product.id)
        if (type !== 'warranty') {
            setAssPopup(false)
            setOldBuyerInsurance(buyerInsurance)
        } else {
            setWarrantyPopup(false)
        }
    }

    const RenderImage = () => {
        return (
            <img
                src={selectedProductImage[sliderRef?.current?.getCurrentIndex()]?.original}
                className="checkRotate"
                id={`imgRef_${sliderRef?.current?.getCurrentIndex()}`}
                onError={(e) => (e.target.src = `${global?.storeDetails?.logoValue}`)}
            />
        )
    }

    const isBidDepotProject = document.querySelector('body').classList.contains('BidAuction')
    const checkBeachThemeClassName = document.body.className == 'liquidationTwo beachLiquidation'
    const checkEmursTheme = document.body.className == 'liquidationTwo emursMck'
    const checkThemeClassName = document.body.className == 'liquidationTwo primeBids'
    const isRetailRUsh = document.body.classList == 'LotsAuction greenField'

    return (
        <>
            {product ? (
                <>
                    {product.market_status === 'open' ? (
                        <form onSubmit={checkbiderrorpopup}>
                            {isAuthenticated ? (
                                <>
                                    <div
                                        className={`${
                                            checkBeachThemeClassName ? '' : 'biddingCnt'
                                        } ${checkEmursTheme ? 'bidEmurs' : null} ${
                                            checkEmursTheme ? 'bidEmurs' : null
                                        }  d-flex justify-content-center bidBeach align-items-flex-start ${
                                            !isAuthenticated && 'notLogged'
                                        }`}
                                    >
                                        {props.hideBid ? (
                                            <></>
                                        ) : (
                                            <div
                                                className={`${
                                                    props.gfThemeDrawer
                                                        ? 'gfSliderContainer bid-wrapper w-100'
                                                        : 'bid-wrapper d-flex justify-content-between'
                                                } ${
                                                    checkEmursTheme && isAuthenticated
                                                        ? 'wInputField'
                                                        : null
                                                } align-items-flex-start ${
                                                    !isAuthenticated && 'notLogged'
                                                }`}
                                            >
                                                {props.gfQuickBid && (
                                                    <PrimaryButton
                                                        label={`Quick Bid ${currencyFormat(
                                                            product.next_bid,
                                                            '',
                                                            'gfQuickBid',
                                                        )}`}
                                                        type="submit"
                                                        btnSize="small"
                                                        onClick={() => {
                                                            setTimeout(() => {
                                                                handleBidButton(product.next_bid)
                                                                props.onClick && props.onClick() // call if it exists
                                                            }, 100)
                                                        }}
                                                        disabled={props.isBidLoading}
                                                    />
                                                )}

                                                {props.isBidAuctionBtn || props.isWizardBtn ? (
                                                    <>{Object.values(mapData(maxBidAmount))}</>
                                                ) : props.drawerBidding ? (
                                                    <>
                                                        {isRetailRUsh && isMobile ? null : (
                                                            <div className="BidFieldContainer">
                                                                <span>Max Bid Amount : </span>
                                                                <div className="mt-2">
                                                                    {Object.values(
                                                                        mapData(bidAmount),
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </>
                                                ) : props.gfQuickBid ? null : (
                                                    <>{Object.values(mapData(bidAmount))}</>
                                                )}
                                                {/* {props.drawerBidding &&
                                                global?.pluginConfiguration?.warranty_return_sku
                                                    ?.enable == 1 &&
                                                isAuthenticated &&
                                                !props.disableWarrantyReturn ? (
                                                    <>
                                                        <div className="buyerAssurance gfAssure mb-5 mt-3">
                                                            <div className="row">
                                                                {mapData(warrantyass)}
                                                                {
                                                                    <div className="col-12">
                                                                        <small className="businessDays">
                                                                            Get a{' '}
                                                                            {global
                                                                                .storeConfigration
                                                                                ?.return_value_days
                                                                                ?.value
                                                                                ? global
                                                                                      .storeConfigration
                                                                                      .return_value_days
                                                                                      .value
                                                                                : 4}{' '}
                                                                            business-day return
                                                                            guarantee.{' '}
                                                                            <a
                                                                                href="#"
                                                                                onClick={() => {
                                                                                    setReturnPopup(
                                                                                        true,
                                                                                    )
                                                                                }}
                                                                            >
                                                                                <u>Learn more</u>
                                                                            </a>
                                                                        </small>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </>
                                                ) : (
                                                    ''
                                                )} */}
                                                {isRetailRUsh && isMobile && (
                                                    <>
                                                        {props.drawerBidding && (
                                                            <span className="text-center d-block">
                                                                Max Bid Amount :{' '}
                                                            </span>
                                                        )}
                                                        <div className="mobileBidView">
                                                            {props.drawerBidding && (
                                                                <div className="BidFieldContainer">
                                                                    <div className="mt-2">
                                                                        {Object.values(
                                                                            mapData(bidAmount),
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {props.gfQuickBid
                                                                ? null
                                                                : props.drawerBidding && (
                                                                      <PrimaryButton
                                                                          label={
                                                                              formik.values
                                                                                  .hard_bid === '1'
                                                                                  ? props.shortText
                                                                                      ? props.shortText
                                                                                      : t(
                                                                                            'place_hard_bid',
                                                                                        )
                                                                                  : props.shortText
                                                                                  ? props.shortText
                                                                                  : 'Place bid'
                                                                          }
                                                                          type="submit"
                                                                          btnSize="small"
                                                                          disabled={bidding_disable}
                                                                      />
                                                                  )}
                                                        </div>
                                                    </>
                                                )}
                                                {!isBargainsProject && (
                                                    <>
                                                        {props.drawerBidding && (
                                                            <div className="drawerBiddingDetails">
                                                                {/* 
                                                                <p className="infoPara">
                                                                    If you win this auction, the
                                                                    total amount—including
                                                                    applicable buyer’s premiums,
                                                                    warranties, taxes, and
                                                                    shipping—will be automatically
                                                                    charged to your default payment
                                                                    method on file.
                                                                </p>
                                                               
                                                                <div className="fee-summary">
                                                                    <p>
                                                                        <span>Max Bid Amount:</span>{' '}
                                                                        <span>
                                                                            USD{' '}
                                                                            {currencyFormat(
                                                                                product.next_bid,
                                                                            )}
                                                                        </span>
                                                                    </p>
                                                                    <p>
                                                                        <span>
                                                                            Buyer&apos;s Premium 15%:
                                                                        </span>{' '}
                                                                        <span>USD XX.XX</span>
                                                                    </p>
                                                                    <p>
                                                                        <span>Warranty:</span>{' '}
                                                                        <span>USD XX.XX</span>
                                                                    </p>
                                                                    <p>
                                                                        <span>Shipping:</span>{' '}
                                                                        <span>USD XX.XX</span>
                                                                    </p>
                                                                    <p>
                                                                        <span>Tax:</span>{' '}
                                                                        <span>USD X.XX</span>
                                                                    </p>
                                                                </div>
                                                                <div className="grandTotal">
                                                                    <p className="total">
                                                                        <span>Grand Total:</span>{' '}
                                                                        <span>
                                                                            USD{' '}
                                                                            {currencyFormat(
                                                                                product.next_bid,
                                                                            )}
                                                                        </span>
                                                                    </p>
                                                                </div> */}

                                                                <div
                                                                    className={
                                                                        isRetailRUsh && isMobile
                                                                            ? 'mt-1'
                                                                            : 'terms mt-4'
                                                                    }
                                                                >
                                                                    By clicking “Place Bid,” you
                                                                    acknowledge{' '}
                                                                    {isBuyBestProject
                                                                        ? 'Buy Best 4 Less'
                                                                        : 'Retail Rush’s'}{' '}
                                                                    <NavLink
                                                                        to="/termsOfService"
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                    >
                                                                        Terms of Agreement
                                                                    </NavLink>{' '}
                                                                    {/* and confirm your commitment to
                                                                    complete the purchase should you
                                                                    win the auction. */}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                                {product.bidtopstatus === 'winner' ? (
                                                    <SecondaryButton
                                                        label={
                                                            formik.values.hard_bid === '1'
                                                                ? 'Increase hard bid'
                                                                : 'Increase proxy bid'
                                                        }
                                                        type="submit"
                                                        btnSize="small"
                                                    />
                                                ) : props.removePopup ? (
                                                    <PrimaryButton
                                                        onClick={formik.handleSubmit}
                                                        type="submit"
                                                        disabled={bidding_disable}
                                                        label={
                                                            formik.values.hard_bid === '1'
                                                                ? props.shortText
                                                                    ? props.shortText
                                                                    : t('place_hard_bid')
                                                                : props.shortText
                                                                ? props.shortText
                                                                : 'Place proxy bid'
                                                        }
                                                        btnSize="small"
                                                    />
                                                ) : props.gfThemeBidSlider ? (
                                                    <PrimaryButton
                                                        label={
                                                            formik.values.hard_bid === '1'
                                                                ? props.shortText
                                                                    ? props.shortText
                                                                    : t('Place Bid')
                                                                : props.shortText
                                                                ? props.shortText
                                                                : 'Place bid'
                                                        }
                                                        type="submit"
                                                        btnSize="small"
                                                        disabled={bidding_disable}
                                                    />
                                                ) : props.gfQuickBid ? null : props.drawerBidding ? (
                                                    <>
                                                        {isRetailRUsh && isMobile ? null : (
                                                            <PrimaryButton
                                                                label={
                                                                    formik.values.hard_bid === '1'
                                                                        ? props.shortText
                                                                            ? props.shortText
                                                                            : t('place_hard_bid')
                                                                        : props.shortText
                                                                        ? props.shortText
                                                                        : 'Place bid'
                                                                }
                                                                type="submit"
                                                                btnSize="small"
                                                                disabled={bidding_disable}
                                                            />
                                                        )}
                                                    </>
                                                ) : (
                                                    <PrimaryButton
                                                        label={
                                                            formik.values.hard_bid === '1'
                                                                ? props.shortText
                                                                    ? props.shortText
                                                                    : t('place_hard_bid')
                                                                : props.shortText
                                                                ? props.shortText
                                                                : 'Place proxy bid'
                                                        }
                                                        className={bidnaaTheme ? 'bidnaaInput' : ''}
                                                        type="submit"
                                                        btnSize="small"
                                                        disabled={bidding_disable}
                                                    />
                                                )}
                                            </div>
                                        )}

                                        {props.enableNextBid && (
                                            <>
                                                {props.searchView ? null : (
                                                    <p className="m-0 pt-3 text-center mx-3 orTxtWrpr">
                                                        {t('or')}
                                                    </p>
                                                )}

                                                <div className={`plcNxtBid`}>
                                                    <PrimaryButton
                                                        onClick={() =>
                                                            handleBidButton(product.next_bid)
                                                        }
                                                        label={
                                                            props.nextbidText ? (
                                                                <span
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: props.nextbidText,
                                                                    }}
                                                                />
                                                            ) : (
                                                                `${t(
                                                                    'place_bid',
                                                                )} - ${currencyFormat(
                                                                    product.next_bid,
                                                                )}
                                                        `
                                                            )
                                                        }
                                                        btnSize="small"
                                                    />
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </>
                            ) : (
                                <div
                                    className={`${
                                        isWizardTheme ? 'd-flex justify-content-center' : ''
                                    }`}
                                >
                                    <PrimaryButton
                                        label={t('login_to_bid')}
                                        btnSize="small"
                                        onClick={() => handleRedirectInternal(history, 'login')}
                                    />
                                </div>
                            )}
                        </form>
                    ) : null}
                    {props.gfQuickBid ? null : global?.pluginConfiguration?.return_assurance
                          ?.enable == 1 &&
                      isAuthenticated &&
                      !props.disableReturnAssurance &&
                      (product.auctionnotes?.trim()?.toLowerCase()?.includes('new') ||
                          product.auctionnotes?.trim()?.toLowerCase()?.includes('damage') ||
                          product.auctionnotes?.trim()?.toLowerCase()?.includes('open box')) ? (
                        <>
                            {product.currentUserBidAmount ||
                            product.bid_or_not ||
                            product.cbidnot ? (
                                //     &&
                                // (product.auctionnotes?.trim()?.toLowerCase()?.includes('new') ||
                                //     product.auctionnotes
                                //         ?.trim()
                                //         ?.toLowerCase()
                                //         ?.includes('open box'))
                                <div className="buyerAssurance">
                                    <div className="row">
                                        {mapData(buyerass)}
                                        {!props?.buyerAssuranceNew && (
                                            <div className="col-12">
                                                <small className="m-0">
                                                    Get a{' '}
                                                    {global.storeConfigration?.return_value_days
                                                        ?.value
                                                        ? global.storeConfigration.return_value_days
                                                              .value
                                                        : 4}{' '}
                                                    business-day return guarantee.{' '}
                                                    <a
                                                        href="#"
                                                        onClick={() => {
                                                            setReturnPopup(true)
                                                        }}
                                                    >
                                                        <u>Learn more</u>
                                                    </a>
                                                </small>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ) : checkThemeClassName ? (
                                <div className="assuranceTxt"></div>
                            ) : (
                                ''
                                // <div>
                                //     You have added return policy with amount{' '}
                                //     {currencyFormat(
                                //         global?.storeConfigration?.buyer_assurance_dollar?.value,
                                //     )}
                                // </div>
                            )}
                        </>
                    ) : (
                        ''
                    )}

                    {props.gfQuickBid || props.drawerBidding ? null : global?.pluginConfiguration
                          ?.warranty_return_sku?.enable == 1 &&
                      isAuthenticated &&
                      !props.disableWarrantyReturn ? (
                        <>
                            {
                                //     &&
                                // (product.auctionnotes?.trim()?.toLowerCase()?.includes('new') ||
                                //     product.auctionnotes
                                //         ?.trim()
                                //         ?.toLowerCase()
                                //         ?.includes('open box'))
                                !isVarifiedGfTheme ? (
                                    <div className="buyerAssurance yyyy">
                                        <div className="row">
                                            {mapData(warrantyass)}
                                            {
                                                <div className="col-12">
                                                    <small className="m-0">
                                                        Get a{' '}
                                                        {global.storeConfigration?.return_value_days
                                                            ?.value
                                                            ? global.storeConfigration
                                                                  .return_value_days.value
                                                            : 4}{' '}
                                                        business-day return guarantee.{' '}
                                                        <a
                                                            href="#"
                                                            onClick={() => {
                                                                setReturnPopup(true)
                                                            }}
                                                        >
                                                            <u>Learn more</u>
                                                        </a>
                                                    </small>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                ) : null
                            }
                        </>
                    ) : (
                        ''
                    )}

                    {!props.removePopup ? (
                        <CustomDialog
                            title={t('confirm_bid')}
                            open={toggleDialog}
                            function={changeDialogStatus}
                        >
                            {global.storeConfigration?.bid_confirmation_text?.value ? (
                                <>
                                    <div
                                        className="amountPop"
                                        dangerouslySetInnerHTML={{
                                            __html: bidpopuptext,
                                        }}
                                    ></div>
                                    {global.storeConfigration?.bidder_pay_notification?.value ==
                                        1 && (
                                        <>
                                            {global.storeDetails.theme === 10 &&
                                            props.data.cbidtext !== 'Starting Price' ? (
                                                <>
                                                    {localStorage.getItem('cbidnot') ||
                                                    props.data.bid_or_not ? null : (
                                                        <div className="alrtTotWrpr">
                                                            <span className="material-icons">
                                                                warning
                                                            </span>
                                                            You will be charged an additional of
                                                            3.1% + 30 cents as transaction fee
                                                        </div>
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    {props.data.cbidnot ||
                                                    props.data.bid_or_not ? null : (
                                                        <div className="alrtTotWrpr">
                                                            <span className="material-icons">
                                                                warning
                                                            </span>
                                                            You will be charged an additional of{' '}
                                                            {`${
                                                                global.storeConfigration
                                                                    ?.charge_addn?.value + '%' ||
                                                                '3.1%'
                                                            }`}{' '}
                                                            + 30 cents per purchase ONLY IF YOU WIN
                                                            THIS ITEM
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </>
                                    )}
                                </>
                            ) : (
                                <>
                                    {/* <div>
                                        <div className="productImage">
                                            <ReactImageGallery
                                                items={product}
                                                thumbnailPosition="bottom"
                                                showThumbnails={false}
                                                showNav={true}
                                                showBullets={false}
                                                showFullscreenButton={false}
                                                showPlayButton={false}
                                                onErrorImageURL={`${global?.storeDetails?.logoValue}`}
                                                originalClass="slidImg img-fluid"
                                                renderItem={RenderImage}
                                                // ref={sliderRef}
                                            />
                                        </div>
                                        <div className="ProductDetails">
                                            <p>Please confirm your bid amount</p>
                                        </div>
                                    </div> */}
                                    <h5>{'You are about to place a bid'}!</h5>
                                    <h5>
                                        {'Please confirm if you want to continue with this action'}
                                    </h5>

                                    {global.storeConfigration?.bidder_pay_notification?.value ==
                                        1 && (
                                        <>
                                            {global.storeDetails.theme === 10 &&
                                            props.data.cbidtext !== 'Starting Price' ? (
                                                <>
                                                    {localStorage.getItem('cbidnot') ||
                                                    props.data.bid_or_not ? null : (
                                                        <div className="alrtTotWrpr">
                                                            <span className="material-icons">
                                                                warning
                                                            </span>
                                                            You will be charged an additional of
                                                            3.1% + 30 cents as transaction fee
                                                        </div>
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    {props.data.cbidnot ||
                                                    props.data.bid_or_not ? null : (
                                                        <div className="alrtTotWrpr">
                                                            <span className="material-icons">
                                                                warning
                                                            </span>
                                                            You will be charged an additional of
                                                            3.1% + 30 cents as transaction fee
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </>
                                    )}
                                </>
                            )}
                            <CurrencyConverterFormat amount={formik.values.wsprice} />
                            <div className="actionWrapper">
                                <Button
                                    className="cancelButton"
                                    onClick={() => setToggleDialog(false)}
                                >
                                    {t('cancel')}
                                </Button>
                                <PrimaryButton
                                    onClick={formik.handleSubmit}
                                    type="button"
                                    disabled={formik.isSubmitting}
                                    label={t('submit')}
                                />
                            </div>
                        </CustomDialog>
                    ) : null}
                    <CustomDialog
                        title={'Bid Amount Error'}
                        open={biderrpopup}
                        function={() => setBiderrpopup(false)}
                    >
                        {/* {global.storeConfigration?.bid_error_text?.value ? (
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: bidpopuptext,
                                }}
                            ></div>
                        ) : ( */}
                        <>
                            {/* <h5>{'You are about to place a bid'}!</h5> */}
                            <h5>{`Please Enter ${currencyFormat(
                                product.next_bid,
                            )} or above.ie In Increments of ${currencyFormat(
                                formik.values.bid_increment,
                            )}`}</h5>
                        </>
                        {/* )} */}
                        <div className="actionWrapper">
                            {/* <Button onClick={() => setToggleDialog(false)}>{'Cancel'}</Button> */}
                            <PrimaryButton
                                onClick={() => setBiderrpopup(false)}
                                type="button"
                                //disabled={formik.isSubmitting}
                                label={'Ok'}
                            />
                        </div>
                    </CustomDialog>
                    <CustomDialog
                        title={'Confirm Popup'}
                        open={asspopup}
                        function={() => {
                            setAssPopup(false)
                            formik.setFieldValue('assurance_check', false)
                        }}
                    >
                        <h5>Are you sure?</h5>
                        <div className="actionWrapper">
                            <div>
                                You will not have any return guarantee protection if you win this
                                item and be subject to our return policy in the Terms & Conditions
                            </div>
                        </div>

                        <div className="d-flex justify-content-end mt-3" style={{ gap: '10px' }}>
                            <PrimaryButton
                                onClick={() => {
                                    setAssPopup(false)
                                    //formik.setFieldValue('check_off', true)
                                    formik.setFieldValue('assurance_check', true)
                                }}
                                type="button"
                                label={'Stay protected'}
                            />
                            <PrimaryButton
                                onClick={() => {
                                    formik.setFieldValue('assurance_check', false)
                                    insert_assurance(0, 'assurance')
                                }}
                                type="button"
                                label={`I'll take the risk`}
                            />
                        </div>
                    </CustomDialog>
                    <CustomDialog
                        title={'Confirm Popup'}
                        open={warrantypopup}
                        function={() => {
                            setWarrantyPopup(false)
                            formik.setFieldValue('warranty_check', false)
                        }}
                    >
                        <h5>Are you sure?</h5>
                        <div className="actionWrapper">
                            <div>
                                You will not have any return guarantee protection if you win this
                                item and be subject to our return policy in the Terms & Conditions
                            </div>
                        </div>

                        <div className="d-flex justify-content-end mt-3" style={{ gap: '10px' }}>
                            <PrimaryButton
                                onClick={() => {
                                    setWarrantyPopup(false)
                                    //formik.setFieldValue('check_off', true)
                                    formik.setFieldValue('warranty_check', true)
                                }}
                                type="button"
                                label={'Stay protected'}
                            />
                            <PrimaryButton
                                onClick={() => {
                                    formik.setFieldValue('warranty_check', false)
                                    insert_assurance(0, 'warranty')
                                }}
                                type="button"
                                label={`I'll take the risk`}
                            />
                        </div>
                    </CustomDialog>
                    <CustomDialog
                        open={return_popup}
                        function={() => {
                            setReturnPopup(false)
                        }}
                    >
                        <h4 className="fw-bold">{"What is Buyer's Assurance?"}</h4>
                        <h5>
                            {global.storeConfigration?.return_value_days?.value
                                ? global.storeConfigration.return_value_days.value
                                : 4}{' '}
                            Business-Day Return Guarantee!
                        </h5>
                        <div className="actionWrapper">
                            <div>
                                If you win the auction,{' '}
                                <b>
                                    you will be charged the additional fee listed in the lot
                                    description.
                                </b>
                                This amount is non-refundable.
                            </div>
                        </div>
                        <div className="actionWrapper">
                            <div>
                                This protection grants you&nbsp;
                                <b>
                                    {global.storeConfigration?.return_value_days_as_string?.value
                                        ? global.storeConfigration.return_value_days_as_string.value
                                        : 'four'}
                                </b>
                                <b>
                                    (
                                    {global.storeConfigration?.return_value_days?.value
                                        ? global.storeConfigration.return_value_days.value
                                        : 4}
                                    )
                                </b>
                                <b> business days from the date of purchase</b> to return the item -
                                no questions asked.
                            </div>
                        </div>

                        <div className="d-flex justify-content-end mt-3" style={{ gap: '10px' }}>
                            <PrimaryButton
                                onClick={() => {
                                    setReturnPopup(false)
                                }}
                                type="button"
                                label={'Ok'}
                            />
                        </div>
                    </CustomDialog>
                </>
            ) : null}
            {isWizardTheme && (
                <>
                    <WizardTermsPopup
                        open={showPopup}
                        onAccept={() => acceptTerms()}
                        handleClose={() => setShowPopup(false)}
                        product={product}
                    />
                </>
            )}
        </>
    )
}

export default Bidding
